import type { ICampaignType, IVariantTemplate } from '~/modules/campaign/types';
import type { CampaignStatus, PlatformProductStatus } from '~/types/graphql';
import type { ICampaignTemplate } from '~/modules/campaign-template/types';

import { IVariantType } from '~/modules/campaign/types';

export enum IAssetTemplateModalType {
  MULTIPLE_VARIANT_A = 'MULTIPLE_VARIANT_A',
  VARIANT_A = IVariantType.VARIANT_A,
  VARIANT_B = IVariantType.VARIANT_B,
}

export interface IAssetTemplateModalData {
  variant: IVariantTemplate;
  campaign: ICampaignTemplate;
  allowTestingBetweenOtherPageType?: boolean;
}

export enum IAssetTemplateAssignedModalType {
  MULTIPLE = 'MULTIPLE',
  VARIANT_B = IVariantType.VARIANT_B,
  PREVIEW = 'PREVIEW',
  COPY = 'COPY',
}

/** The other experiment locking a template, whichever type matched — template, price or URL. */
export interface IAssetTemplateRemoveConfirmState {
  campaignId: string;
  campaignName?: string;
  campaignType: ICampaignType;
  /** Set for a PRICE lock — the price record to delete. */
  priceId?: string;
  /** Set for a URL lock — the destination record to delete. */
  urlId?: string;
}

/**
 * One experiment holding a template, as listed by the Edit experiments modal. A price test holds the
 * template through the product it runs on and a URL test through the page it sends traffic to, so
 * that record is what names the row.
 */
export interface IExperimentUsage extends IAssetTemplateRemoveConfirmState {
  campaignStatus?: CampaignStatus;
  resourceName?: string;
  /** Shopify status of that product — Active vs. Unlisted, shown alongside the name. Price tests only. */
  productStatus?: PlatformProductStatus;
}

export const PICKED_TEMPLATE_FOR_VARIANT_A = [
  IAssetTemplateModalType.VARIANT_A,
  IAssetTemplateModalType.MULTIPLE_VARIANT_A,
];
